import { takeLatest } from 'redux-saga/effects';
import {
  GOOGLE_GET_PLACE_DETAILS,
  AUTOCOMPLETE_SEARCH_WITH_GOOGLE_START,
} from 'redux/actions/types';
import {
  getAutocompleteOptionsWithGoogle,
  getPlaceDetailsFromGoogleByPlaceId,
} from './autocomplete-saga';

export default function* autocompleteRootSagas() {
  yield takeLatest(
    AUTOCOMPLETE_SEARCH_WITH_GOOGLE_START,
    getAutocompleteOptionsWithGoogle,
  );
  yield takeLatest(
    GOOGLE_GET_PLACE_DETAILS,
    getPlaceDetailsFromGoogleByPlaceId,
  );
}
